var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-select',{attrs:{"on-search":_vm.filtra,"options":_vm.optionsFilter,"placeholder":_vm.texto,"filterable":false,"disabled":_vm.disabled},on:{"input":_vm.input},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},[_c('span',{attrs:{"slot":"no-options"},slot:"no-options"},[_vm._v("\n      "+_vm._s(_vm.vazio)+"\n    ")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aa12f8f","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search-select.vue
// module id = 799
// module chunks = 245